import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'vault-page-toolbar',
  templateUrl: './page-toolbar.component.html',
  styleUrls: ['./page-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageToolbarComponent {}
